import React from 'react';
import { Fees, OnlineCare, Secure, Insurance, Heart } from '../assets/icons';
const Ribbon = () => {
  return (
    <div className='ribbonWrapper'>
      <span className='ticker ticker1'>
        <span>
          <OnlineCare />{' '}
        </span>
        <span>Online care, anytime, anywhere</span>
      </span>
      <span className='ticker ticker2'>
        <span>
          {' '}
          <Insurance />
        </span>

        <span>No insurance, No problem</span>
      </span>
      <span className='ticker ticker3'>
        <span>
          <Secure />
        </span>

        <span>Secure medical records</span>
      </span>
      <span className='ticker ticker4'>
        <span>
          <Fees />
        </span>

        <span> No hidden fees</span>
      </span>
      <span className='ticker ticker5'>
        <span>
          <Heart />
        </span>

        <span>Personalized treatment plans</span>
      </span>
    </div>
  );
};

export default Ribbon;
